import { getRequest } from '@fo-apis/axios';

const getDisplayCategory = () =>
  getRequest({
    url: '/api/v1/display/category',
  });

const getCategoryGoodList = (params, categoryNumber) =>
  getRequest(
    {
      url: `/api/v1/display/category/goods/${categoryNumber}`,
      params,
    },
    { skipError: true }
  );

const getBannerList = (mainFunctionKindCode) =>
  getRequest({
    url: `/api/v1/display/banner/${mainFunctionKindCode}`,
  });

/**
 * ECMJ
 * 작업자 : 윤희영
 * 로그인전 로그인팝업 목록
 */
const getLoginBannerList = () =>
  getRequest({
    url: `/api/v1/display/banner/login`,
  });

const displayApi = {
  getCategoryGoodList,
  getDisplayCategory,
  getBannerList,
  getLoginBannerList,
};

export default displayApi;
